<form
  [formGroup]="workspaceForm"
  (ngSubmit)="confirmWorkSpace()"
  #ngForm="ngForm"
  [class.submitted]="ngForm.submitted"
  [class.no-max-width]="noMaxWidth"
>
  <app-input-field [control]="workspaceForm.controls.name" [noLabel]="true" [big]="true">
    <input
      type="text"
      autocomplete="company-name"
      appAutofocus
      formControlName="name"
      placeholder="Workspace Name"
      data-test-id="tenant-name-field"
    />
  </app-input-field>
  <app-input-field [control]="workspaceForm.controls.path" [noLabel]="true" [big]="true">
    <input
      type="text"
      autocomplete="company-path"
      formControlName="path"
      placeholder="Public URL"
      data-test-id="tenant-path-field"
      (input)="manuallyChangedPath = true"
    />
    <div *appInputPost class="tenant-path">
      @if (workspaceForm.value.path && !checkingTenantPath) {
        @if (validTenantPath) {
          <app-svg src="/assets/icons/check-circle.svg" color="green"></app-svg>
        } @else {
          <app-svg src="/assets/icons/cross-circle.svg" color="warn"></app-svg>
        }
      }
      @if (!tenant && tenantPathError) {
        <app-svg src="/assets/icons/cross-circle.svg" color="warn"></app-svg>
      }
      @if (workspaceForm.value.path && checkingTenantPath) {
        <app-loading-indicator size="smaller"></app-loading-indicator>
      }
      <div class="picflow-domain">.picflow.com</div>
    </div>
  </app-input-field>
  @if (!hideCta) {
    <button
      appButton
      name="confirm"
      location="workspace-form"
      color="primary"
      [center]="true"
      height="4"
      size="3"
      class="cta"
      spacing="full"
      shape="round"
      data-test-id="workspace-form-cta"
    >
      <span [class.hidden-text]="savingWorkspace()">{{ cta }}</span>
      @if (savingWorkspace()) {
        <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
      }
    </button>
  }
  <ng-content></ng-content>
</form>
